module.exports = __webpack_public_path__ + "img/广告投放营销平台.acb78748.png";